import { validationIsEqual } from '../status';
import {
    validateEmail,
    validateName,
    validateAlphaNumericString,
    validateNumericString,
    validatePassportNumber,
} from '@om/validation';

import { getIdNumberValue } from '@om/redux/selectors/personalAccident/personalDetails';
import {
    RELATIONSHIP_SET_VALUE,
    FIRST_NAME_SET_VALUE,
    LAST_NAME_SET_VALUE,
    ID_NUMBER_SET_VALUE,
    EMAIL_SET_VALUE,
    ADDRESS_SET_VALUE,
    setRelationshipValid,
    setIdNumberValid,
    setAddressValid,
    setFirstNameValid,
    setLastNameValid,
    setEmailValid,
} from '../../../actions/personalAccident/nextOfKin';
import { validateKePassport } from '@om/validation/src/validators/ke-passport-validator';

let prevValidationAction = null;
export const nextOfKinValidation = (store, next, action) => {
    const idNumber = getIdNumberValue(store.getState());

    const validationAction = (() => {
        let error = null;

        const validateString = (value, min, subject) => {
            const validators = [validateName, validateAlphaNumericString, validateNumericString];

            let customError = null;

            for (const validate of validators) {
                customError = validate(value, { min, subject });
                if (!customError) break;
            }

            return customError;
        };
        switch (action.type) {
            case RELATIONSHIP_SET_VALUE:
                error = validateName(action.value, {
                    subject: 'Gender',
                    min: 2,
                });
                return setRelationshipValid(error);

            case FIRST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'First Name',
                });
                return setFirstNameValid(error);

            case LAST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Last Name',
                });
                return setLastNameValid(error);

            case ID_NUMBER_SET_VALUE:
                if (idNumber.value === action.value) {
                    error = 'You cannot use your own ID number';
                }

                if (error === null) {
                    error = validatePassportNumber(action.value, { min: 8, max: 15, required: true });
                }

                return setIdNumberValid(error);

            case EMAIL_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailValid(error);

            case ADDRESS_SET_VALUE:
                error = validateString(action.value);
                return setAddressValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
